import { Image } from "./image";
import { Project } from "./project";
import React from "react";

export const Portfolio = (props) => {
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Portfolio</h2>
          <p>
            A list of out Certificates and Projects.
          </p>
        </div>
        <div className="subsection-title">
          <h3>Certificates</h3>
        </div>
        <div className="row">
        <div className="portfolio-items">
            {props.data
                      ? props.data.Certificates.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className="col-lg-4 col-md-4 col-sm-6 col-xs-6"
                >
                    <Image
                      title={d.title}
                      link={d.link}
                      image={d.image} 
                    />
                </div>
              ))
            : "Loading..."}
          </div>
        </div>
        
        <div className="subsection-title">
          <h3>Projects</h3>
        </div>
        <div className="row">
        <div className="portfolio-items mb-4">
        {props.data
                      ? props.data.Projects.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className="col-lg-6 col-md-12 col-sm-12 col-xs-12"
                >
                    <Project
                      title={d.title}
                      description={d.description}
                      link={d.link}
                      image={d.image} 
                    />
                </div>
              ))
            : "Loading..."}
        </div>
        </div>
      </div>
    </div>
  );
};